(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3021],{

/***/ 23021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ stories; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/layout/MainLayout.js + 36 modules
var MainLayout = __webpack_require__(81842);
// EXTERNAL MODULE: ./src/layout/centerLayout/CenterLayout.js + 2 modules
var CenterLayout = __webpack_require__(33134);
// EXTERNAL MODULE: ./src/components/pages/news/ListNav.js
var ListNav = __webpack_require__(6790);
// EXTERNAL MODULE: ./src/utils/hooks/useRequest.js
var useRequest = __webpack_require__(16314);
;// CONCATENATED MODULE: ./src/utils/hooks/news/useStoriesData.js


var requestConfig = {
    listUrl: "/api/news/newsList.htm?type=0&size=10",
    detailUrl: "/api/news/newsDetail.htm"
};
function useStoriesList(param) {
    var lang = param.lang, page = param.page;
    var ref = (0,useRequest/* default */.Z)({
        url: "".concat(requestConfig.listUrl, "&page=").concat(page, "&lang=").concat(lang)
    }), data = ref.data, error = ref.error;
    var result = (0,react.useMemo)(function() {
        if (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return {
                done: true,
                error: error
            };
        }
        if (data) {
            var ref, ref1;
            return {
                done: true,
                data: (data === null || data === void 0 ? void 0 : (ref = data.newsList) === null || ref === void 0 ? void 0 : ref.list) || [],
                end: page * 10 >= Number(data === null || data === void 0 ? void 0 : (ref1 = data.newsList) === null || ref1 === void 0 ? void 0 : ref1.count)
            };
        }
        return {};
    }, [
        data,
        error
    ]);
    return result;
}
function useStoriesDetail(param) {
    var id = param.id;
    var ref = (0,useRequest/* default */.Z)({
        url: "".concat(requestConfig.detailUrl, "?id=").concat(id)
    }), data = ref.data, error = ref.error;
    var result = (0,react.useMemo)(function() {
        if (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            return {
                done: true,
                error: error
            };
        }
        if (data) {
            return {
                done: true,
                data: (data === null || data === void 0 ? void 0 : data.news) || {}
            };
        }
        return {};
    }, [
        data,
        error
    ]);
    return result;
}
/* harmony default export */ var useStoriesData = ({
    useStoriesList: useStoriesList,
    useStoriesDetail: useStoriesDetail
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var esm = __webpack_require__(28677);
// EXTERNAL MODULE: ./styles/pages/news/stories/index.module.scss
var index_module = __webpack_require__(81443);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./pages/news/stories/index.js











function Page(param) {
    var apiData = param.apiData;
    var ref;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,esm/* useTranslation */.$G)("pages", {
        keyPrefix: "news.stories"
    }), t = ref1.t, i18n = ref1.i18n;
    var contentRef = (0,react.useRef)(null);
    var id = router.query.id || (apiData === null || apiData === void 0 ? void 0 : (ref = apiData.listData) === null || ref === void 0 ? void 0 : ref[0].id) || "";
    var ref2 = useStoriesDetail({
        id: id
    }), detailData = ref2.data;
    var detailObject = detailData || apiData.detailData || {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, {
        pageClassName: (index_module_default()).pageContainer,
        headProps: {
            title: t("meta.title"),
            keyword: t("meta.keyword"),
            canonical: "https://www.bitop.com".concat(i18n.language === "en" ? "/en" : "", "/news/stories")
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CenterLayout/* default */.Z, {
            detail: detailObject,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: (index_module_default()).container,
                children: !router.query.id ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: (index_module_default()).pageList,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListNav/* default */.Z, {
                        className: (index_module_default()).listNav,
                        defaultlist: apiData.listData,
                        tab: "/stories",
                        listHook: useStoriesList
                    }, Date.now())
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: (index_module_default()).contents,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (index_module_default()).title,
                                children: detailObject === null || detailObject === void 0 ? void 0 : detailObject.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: (index_module_default()).time,
                                children: i18n.language === "en" ? moment_default()(detailObject.date).format("[Published on] MMM Do, YYYY") : moment_default()(detailObject.date).format("YYYY年MM月DD日[发布]")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: contentRef,
                                className: (index_module_default()).detail,
                                dangerouslySetInnerHTML: {
                                    __html: detailObject.content
                                }
                            })
                        ]
                    })
                })
            })
        })
    });
}
Page.propTypes = {
    apiData: prop_types_default().instanceOf(Object).isRequired
};
var __N_SSP = true;
/* harmony default export */ var stories = (Page);


/***/ }),

/***/ 6790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28677);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_common_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43412);
/* harmony import */ var _components_common_Empty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88984);
/* harmony import */ var _ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28258);
/* harmony import */ var _ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10__);













function ListNav(param) {
    var defaultlist = param.defaultlist, tab = param.tab, className = param.className, listHook = param.listHook;
    var ref, ref1;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var locale = router.locale, query = router.query;
    var ref2 = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("pages", {
        keyPrefix: "news.announcement"
    }), t = ref2.t, i18n = ref2.i18n;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), page = ref3[0], setPage = ref3[1];
    var ref4 = listHook({
        lang: locale,
        page: page
    }), data = ref4.data, end = ref4.end;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), list = ref5[0], setList = ref5[1];
    var listData = list || defaultlist || [];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (data) {
            setList(function(prevlist) {
                var _newList;
                var newList = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(prevlist || []);
                (_newList = newList).push.apply(_newList, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(data.filter(function(item) {
                    return newList.every(function(i) {
                        return i.id !== item.id;
                    });
                })));
                return newList;
            });
        }
    }, [
        data
    ]);
    var id = (query === null || query === void 0 ? void 0 : query.id) || ((ref = list || defaultlist) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.id);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10___default().container), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, className, !!className)),
        children: [
            listData.length ? listData.map(function(item) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, (_ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10___default().active), Number(id) === Number(item.id))),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                        href: "/news".concat(tab, "/").concat(item.id),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "/news".concat(tab, "/").concat(item.id),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                        className: (_ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10___default().title),
                                        children: [
                                            item.type !== undefined ? "【".concat(t("type.".concat(item.type)), "】") : "",
                                            item === null || item === void 0 ? void 0 : item.title
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10___default().time),
                                        children: i18n.language === "en" ? moment__WEBPACK_IMPORTED_MODULE_6___default()(item.time || item.date).format("[Published on] MMM Do, YYYY") : moment__WEBPACK_IMPORTED_MODULE_6___default()(item.time || item.date).format("YYYY年MM月DD日[发布]")
                                    })
                                ]
                            })
                        })
                    })
                }, item.id);
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_ListNav_module_scss__WEBPACK_IMPORTED_MODULE_10___default().empty),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Empty__WEBPACK_IMPORTED_MODULE_8__/* .NoData */ .J, {})
            }),
            tab !== "/stories" || end ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Button__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
                variant: "plane",
                onClick: function() {
                    return setPage(function(prevPage) {
                        return prevPage + 1;
                    });
                },
                children: t("loadmore")
            })
        ]
    });
}
ListNav.propTypes = {
    defaultlist: prop_types__WEBPACK_IMPORTED_MODULE_12___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_12___default().instanceOf(Object)),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    tab: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().string),
    listHook: (prop_types__WEBPACK_IMPORTED_MODULE_12___default().func)
};
ListNav.defaultProps = {
    defaultlist: [],
    className: "",
    tab: "",
    listHook: function() {
        return null;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (ListNav);


/***/ }),

/***/ 33134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ centerLayout_CenterLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js + 17 modules
var mobxreact_esm = __webpack_require__(50828);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 23 modules
var esm = __webpack_require__(28677);
// EXTERNAL MODULE: ./src/layout/centerLayout/CenterLayout.module.scss
var CenterLayout_module = __webpack_require__(47472);
var CenterLayout_module_default = /*#__PURE__*/__webpack_require__.n(CenterLayout_module);
// EXTERNAL MODULE: ./src/components/common/ServicePlatformChoice/ServicePlatformChoice.js
var ServicePlatformChoice = __webpack_require__(43051);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/store/index.js + 10 modules
var store = __webpack_require__(26721);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./styles/pages/center/breadCrumbs.module.scss
var breadCrumbs_module = __webpack_require__(37125);
var breadCrumbs_module_default = /*#__PURE__*/__webpack_require__.n(breadCrumbs_module);
;// CONCATENATED MODULE: ./src/components/pages/center/breadCrumbs.js







function BreadCrumbs(param) {
    var _detail = param.detail, detail = _detail === void 0 ? {} : _detail;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)("pages").t;
    var breadCrumbsArr = router.pathname.split("/").filter(function(breadCrumbs) {
        return breadCrumbs !== "";
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (breadCrumbs_module_default()).breadCrumbs,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (breadCrumbs_module_default()).crumb,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: t("home.header")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (breadCrumbs_module_default()).arrow,
                children: ">"
            }),
            breadCrumbsArr.map(function(breadCrumbs, index) {
                var linkBuilder = "";
                var textBuilder = "";
                var match = breadCrumbs.match(/\[(.*?)\]/);
                if (match) {
                    var newArray = breadCrumbsArr.map(function(item) {
                        return item.replace(match[0], router.query[match[1]]);
                    });
                    linkBuilder = newArray.slice(0, index + 1).join("/");
                    textBuilder = detail.title ? detail.title : router.query[match[1]];
                } else {
                    linkBuilder = breadCrumbsArr.slice(0, index + 1).join("/");
                    textBuilder = t("".concat(breadCrumbsArr.slice(0, index + 1).join("."), ".header"));
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (breadCrumbs_module_default()).crumb,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/".concat(linkBuilder),
                                children: t("".concat(textBuilder))
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (breadCrumbs_module_default()).arrow,
                            children: ">"
                        })
                    ]
                }, breadCrumbs);
            })
        ]
    });
}
BreadCrumbs.propTypes = {
    detail: prop_types_default().instanceOf(Object)
};
BreadCrumbs.defaultProps = {
    detail: {}
};
/* harmony default export */ var breadCrumbs = (BreadCrumbs);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/pages/center/imgs/SideBarIcon.js
var SideBarIcon = __webpack_require__(89290);
// EXTERNAL MODULE: ./styles/pages/center/sideBar.module.scss
var sideBar_module = __webpack_require__(91179);
var sideBar_module_default = /*#__PURE__*/__webpack_require__.n(sideBar_module);
;// CONCATENATED MODULE: ./src/components/pages/center/sideBar.js








function SideBar() {
    var ref;
    var router = (0,next_router.useRouter)();
    var pathNameArr = router.pathname.split("/").filter(function(x) {
        return x !== "";
    });
    var t = (0,esm/* useTranslation */.$G)("pages").t;
    var keyPrefix = ((ref = pathNameArr[0]) === null || ref === void 0 ? void 0 : ref.replace("App", "")) || "";
    var textObj = t(keyPrefix, {
        returnObjects: true
    });
    var combineNav = typeof textObj === "object" ? Object.keys(textObj).filter(function(x) {
        return x !== "header";
    }) : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (sideBar_module_default()).tabs,
        children: combineNav.map(function(section) {
            var linkBuilder = [
                "",
                pathNameArr[0]
            ].concat(section).join("/");
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: linkBuilder,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((sideBar_module_default()).tabBlock, (0,_define_property/* default */.Z)({}, (sideBar_module_default()).active, pathNameArr.includes(section))),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (sideBar_module_default()).tabRow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBarIcon/* default */.Z, {
                                icon: section
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: t("".concat(keyPrefix, ".").concat(section, ".header"))
                            })
                        ]
                    })
                })
            }, section);
        })
    });
}
/* harmony default export */ var sideBar = (SideBar);

;// CONCATENATED MODULE: ./src/layout/centerLayout/CenterLayout.js













function CenterLayout(param) {
    var children = param.children, _detail = param.detail, detail = _detail === void 0 ? "" : _detail, _showBreadcrumbs = param.showBreadcrumbs, showBreadcrumbs = _showBreadcrumbs === void 0 ? true : _showBreadcrumbs, _nativeApp = param.nativeApp, nativeApp = _nativeApp === void 0 ? false : _nativeApp;
    var ref;
    var router = (0,next_router.useRouter)();
    var user = (0,store/* useStore */.oR)().auth.user;
    var pathNameArr = router.pathname.split("/").filter(function(x) {
        return x !== "";
    });
    var keyPrefix = ((ref = pathNameArr[0]) === null || ref === void 0 ? void 0 : ref.replace("App", "")) || "";
    var t = (0,esm/* useTranslation */.$G)("pages").t;
    var getPlatform = function() {
        if (user === false || user === undefined) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicePlatformChoice/* default */.Z, {
                className: (CenterLayout_module_default()).newBg
            });
        }
        return "";
    };
    (0,react.useEffect)(function() {
        var intervalId = setInterval(function() {
            getPlatform();
        }, 1000);
        return function() {
            clearInterval(intervalId);
        };
    }, [
        user
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: (CenterLayout_module_default()).page,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((CenterLayout_module_default()).bg, (0,_define_property/* default */.Z)({}, (CenterLayout_module_default()).nativeApp, nativeApp))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((CenterLayout_module_default()).page, (0,_define_property/* default */.Z)({}, (CenterLayout_module_default()).nativeApp, nativeApp)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (CenterLayout_module_default()).banner,
                        children: t("header", {
                            keyPrefix: keyPrefix
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (CenterLayout_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sideBar, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (CenterLayout_module_default()).contentBody,
                                children: [
                                    showBreadcrumbs ? /*#__PURE__*/ (0,jsx_runtime.jsx)(breadCrumbs, {
                                        detail: detail
                                    }) : "",
                                    children
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CenterLayout_module_default()).space,
                children: "\xa0"
            })
        ]
    });
}
CenterLayout.propTypes = {
    children: (prop_types_default()).node.isRequired,
    detail: prop_types_default().instanceOf(Object),
    showBreadcrumbs: (prop_types_default()).bool,
    nativeApp: (prop_types_default()).bool
};
CenterLayout.defaultProps = {
    detail: {},
    showBreadcrumbs: true,
    nativeApp: false
};
/* harmony default export */ var centerLayout_CenterLayout = ((0,mobxreact_esm/* observer */.Pi)(CenterLayout));


/***/ }),

/***/ 28258:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"ListNav_root_include_ru__mRtut","footer":"ListNav_footer__Nmbb6","container":"ListNav_container__9aO7l","title":"ListNav_title__SCpe4","time":"ListNav_time__m4DC5","empty":"ListNav_empty__a2dzH"};

/***/ }),

/***/ 47472:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"CenterLayout_root_include_ru__blKzN","footer":"CenterLayout_footer__5PgOb","page":"CenterLayout_page__6fQI0","nativeApp":"CenterLayout_nativeApp__pfCso","bg":"CenterLayout_bg__2WniR","banner":"CenterLayout_banner__sq2gT","content":"CenterLayout_content__eY5wB","contentBody":"CenterLayout_contentBody__YJyDQ","module":"CenterLayout_module___SJHu","space":"CenterLayout_space__JMQ30","newBg":"CenterLayout_newBg__Mvm8r"};

/***/ }),

/***/ 37125:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"breadCrumbs_root_include_ru__Dqz1A","footer":"breadCrumbs_footer___cwRK","breadCrumbs":"breadCrumbs_breadCrumbs__mQKJ0","crumb":"breadCrumbs_crumb__76WNe","arrow":"breadCrumbs_arrow__D2zgN"};

/***/ }),

/***/ 91179:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"sideBar_root_include_ru__IKwbm","footer":"sideBar_footer__7Dwv4","tabs":"sideBar_tabs__hkgpW","tabBlock":"sideBar_tabBlock__jlNr2","active":"sideBar_active__2ALEB","tabRow":"sideBar_tabRow__Z0Ych"};

/***/ }),

/***/ 81443:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root_include_ru":"stories_root_include_ru__dtMK9","footer":"stories_footer__p1USx","title":"stories_title__mjWDr","twitter":"stories_twitter__FzaC3","contents":"stories_contents__8K7F9","detail":"stories_detail__fiyUO","container":"stories_container__HdPif","listNav":"stories_listNav__eDRLW","pageList":"stories_pageList__LAlQd","time":"stories_time__d3OSU"};

/***/ })

}]);